const items_data = [
	// bids data
	{
		id: 'item_1',
		image: '/images/products/item_1.jpg',
		title: 'ETH Me Outside',
		price: 1.55,
		likes: 159,
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		creatorImage: '/images/avatars/avatar_7.jpg',
		ownerImage: '/images/avatars/avatar_1.jpg',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
	},
	{
		id: 'item_2',
		image: '/images/products/item_2.jpg',
		title: 'ETH Me Outside',
		price: 1.55,
		likes: 159,
		creatorImage: '/images/avatars/avatar_7.jpg',
		ownerImage: '/images/avatars/avatar_1.jpg',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
	},
	{
		id: 'item_3',
		image: '/images/products/item_3.jpg',
		title: 'ETH Me Outside',
		price: 1.55,
		likes: 159,
		creatorImage: '/images/avatars/avatar_7.jpg',
		ownerImage: '/images/avatars/avatar_1.jpg',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
	},
	{
		id: 'item_4',
		image: '/images/products/item_4.jpg',
		title: 'ETH Me Outside',
		price: 1.55,
		likes: 159,
		creatorImage: '/images/avatars/avatar_7.jpg',
		ownerImage: '/images/avatars/avatar_1.jpg',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
	},
	{
		id: 'item_5',
		image: '/images/products/item_5.jpg',
		title: 'ETH Me Outside',
		price: 1.55,
		likes: 159,
		creatorImage: '/images/avatars/avatar_7.jpg',
		ownerImage: '/images/avatars/avatar_1.jpg',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
	},
	{
		id: 'item_6',
		image: '/images/products/item_6.jpg',
		title: 'ETH Me Outside',
		price: 1.55,
		likes: 159,
		creatorImage: '/images/avatars/avatar_7.jpg',
		ownerImage: '/images/avatars/avatar_1.jpg',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
	},
	{
		id: 'item_7',
		image: '/images/products/item_7.jpg',
		creatorImage: '/images/avatars/creator_4.png',
		ownerImage: '/images/avatars/owner_4.png',
		price: '10 ETH',
		title: 'Splendid Girl',
		likes: '100',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
	},
	{
		id: 'item_8',
		image: '/images/products/item_8.jpg',
		creatorImage: '/images/avatars/creator_1.png',
		ownerImage: '/images/avatars/owner_1.png',
		price: '1.3 ETH',
		title: 'Monkeyme#155',
		likes: '25',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
	},
	{
		id: 'item_9',
		image: '/images/products/item_9.jpg',
		creatorImage: '/images/avatars/creator_4.png',
		ownerImage: '/images/avatars/owner_4.png',
		price: '10 ETH',
		title: 'Splendid Girl',
		likes: '100',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
	},
	{
		id: 'item_10',
		image: '/images/products/item_10.jpg',
		creatorImage: '/images/avatars/creator_2.png',
		ownerImage: '/images/avatars/owner_7.png',
		price: '1.75 ETH',
		title: 'Artof Eve',
		likes: '15',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
	},
	{
		id: 'item_11',
		image: '/images/products/item_11.jpg',
		creatorImage: '/images/avatars/creator_8.png',
		ownerImage: '/images/avatars/owner_5.png',
		price: '0.8 ETH',
		title: 'Asuna #1649',
		likes: '34',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
	},
	{
		id: 'item_12',
		image: '/images/products/item_12_lg.jpg',
		creatorImage: '/images/avatars/creator_3.png',
		ownerImage: '/images/avatars/owner_3.png',
		price: '4.7 ETH',
		likes: '260',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		title: 'Wow Frens',
	},
	{
		id: 'item_13',
		image: '/images/products/item_13_lg.jpg',
		creatorImage: '/images/avatars/creator_3.png',
		ownerImage: '/images/avatars/owner_3.png',
		price: '4.7 ETH',
		likes: '260',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		title: '051_Hart',
	},
	{
		id: 'item_14',
		image: '/images/products/item_14_lg.jpg',
		creatorImage: '/images/avatars/creator_3.png',
		ownerImage: '/images/avatars/owner_3.png',
		price: '4.7 ETH',
		likes: '260',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		title: 'Lila Spacex',
	},
	{
		id: 'item_15',
		image: '/images/products/item_15_lg.jpg',
		creatorImage: '/images/avatars/creator_3.png',
		ownerImage: '/images/avatars/owner_3.png',
		price: '4.7 ETH',
		likes: '260',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		title: 'Bored Bunny',
	},
	{
		id: 'item_16',
		image: '/images/products/item_16_lg.jpg',
		creatorImage: '/images/avatars/creator_3.png',
		ownerImage: '/images/avatars/owner_3.png',
		price: '4.7 ETH',
		likes: '260',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		title: 'MadeByM1KE',
	},
	{
		id: 'item_17',
		image: '/images/products/item_17.jpg',
		creatorImage: '/images/avatars/creator_2.png',
		ownerImage: '/images/avatars/owner_2.png',
		price: '9.3712 ETH',
		title: 'Azuki #4017',
		likes: '334',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
	},
	{
		id: 'item_18',
		image: '/images/products/item_18.jpg',
		creatorImage: '/images/avatars/creator_9.png',
		ownerImage: '/images/avatars/owner_8.png',
		price: '7.3 ETH',
		title: 'Block #2788',
		likes: '52',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
	},
	{
		id: 'item_19',
		image: '/images/products/item_19.jpg',
		creatorImage: '/images/avatars/creator_6.png',
		ownerImage: '/images/avatars/owner_4.png',
		price: '0.32 ETH',
		title: 'Crypto bull #6195',
		likes: '90',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
	},
	{
		id: 'item_20',
		image: '/images/products/item_20_square.jpg',
		creatorImage: '/images/avatars/avatar_7.jpg',
		ownerImage: '/images/avatars/avatar_1.jpg',
		price: '4.7 ETH',
		likes: '260',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		title: 'TSARÉVNA',
	},
	{
		id: 'item_21',
		image: '/images/products/item_15_lg.jpg',
		creatorImage: '/images/avatars/creator_3.png',
		ownerImage: '/images/avatars/owner_3.png',
		price: '4.7 ETH',
		likes: '260',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		title: 'Bored Bunny',
	},
	{
		id: 'item_22',
		image: '/images/products/item_8.jpg',
		creatorImage: '/images/avatars/creator_3.png',
		ownerImage: '/images/avatars/owner_3.png',
		price: '4.7 ETH',
		likes: '260',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		title: 'Bored Bunny',
	},
	{
		id: 'item_23',
		image: '/images/products/item_23_sm.jpg',
		creatorImage: '/images/avatars/creator_3.png',
		ownerImage: '/images/avatars/owner_3.png',
		price: '4.7 ETH',
		likes: '260',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		title: 'Bored Bunny',
	},
	{
		id: 'item_24',
		image: '/images/products/item_3.jpg',
		creatorImage: '/images/avatars/creator_3.png',
		ownerImage: '/images/avatars/owner_3.png',
		price: '4.7 ETH',
		likes: '260',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		title: 'Bored Bunny',
	},
	{
		id: 'item_25',
		image: '/images/products/item_25.jpg',
		creatorImage: '/images/avatars/avatar_7.jpg',
		ownerImage: '/images/avatars/avatar_1.jpg',
		price: '4.7 ETH',
		likes: '260',
		creatorname: 'Origin Morish',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		title: 'VR Space_286',
	},
	{
		id: 'item_26',
		image: '/images/products/item_1.jpg',
		title: 'ETH Me Outside',
		price: 1.55,
		likes: 159,
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		creatorImage: '/images/avatars/avatar_7.jpg',
		ownerImage: '/images/avatars/avatar_1.jpg',
		creatorname: '@creative_world',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
	},
	{
		id: 'item_27',
		image: '/images/products/item_27_square.jpg',
		creatorImage: '/images/avatars/creator_3.png',
		ownerImage: '/images/avatars/owner_3.png',
		price: '4.7 ETH',
		likes: '260',
		creatorname: 'Lazy Panda',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		title: 'Amazing Impact DOT art',
	},
	{
		id: 'item_28',
		image: '/images/products/item_28_square.jpg',
		creatorImage: '/images/avatars/creator_3.png',
		ownerImage: '/images/avatars/owner_3.png',
		price: '4.7 ETH',
		likes: '260',
		creatorname: 'Impact DOT stars',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		title: 'Punkie Cat',
	},
	{
		id: 'item_29',
		image: '/images/products/item_29_square.jpg',
		creatorImage: '/images/avatars/creator_3.png',
		ownerImage: '/images/avatars/owner_3.png',
		price: '4.7 ETH',
		likes: '260',
		creatorname: 'Origin Morish',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		title: 'VR Space_283',
	},
	{
		id: 'item_30',
		image: '/images/products/item_30_square.jpg',
		creatorImage: '/images/avatars/creator_3.png',
		ownerImage: '/images/avatars/owner_3.png',
		price: '4.7 ETH',
		likes: '260',
		creatorname: 'Lazy Panda',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		title: 'Metasmorf',
	},
	{
		id: 'item_31',
		image: '/images/products/item_31_square.jpg',
		creatorImage: '/images/avatars/creator_3.png',
		ownerImage: '/images/avatars/owner_3.png',
		price: '4.7 ETH',
		likes: '260',
		creatorname: 'Impact DOT stars',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		title: 'PankySkal',
	},
	{
		id: 'item_32',
		image: '/images/products/item_32_square.jpg',
		creatorImage: '/images/avatars/creator_3.png',
		ownerImage: '/images/avatars/owner_3.png',
		price: '4.7 ETH',
		likes: '260',
		creatorname: 'Origin Morish',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		title: 'VR Space_287',
	},

	{
		id: 'item_33',
		image: '/images/nft-game/nft_game_character_1.png',
		creatorImage: '/images/avatars/creator_3.png',
		ownerImage: '/images/avatars/owner_3.png',
		price: '4.7 ETH',
		likes: '260',
		creatorname: 'Origin Morish',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		title: 'VR Space_287',
	},
	{
		id: 'item_34',
		image: '/images/nft-game/nft_game_character_2.png',
		creatorImage: '/images/avatars/creator_3.png',
		ownerImage: '/images/avatars/owner_3.png',
		price: '4.7 ETH',
		likes: '260',
		creatorname: 'Origin Morish',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		title: 'VR Space_287',
	},
	{
		id: 'item_35',
		image: '/images/nft-game/nft_game_character_3.png',
		creatorImage: '/images/avatars/creator_3.png',
		ownerImage: '/images/avatars/owner_3.png',
		price: '4.7 ETH',
		likes: '260',
		creatorname: 'Origin Morish',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		title: 'VR Space_287',
	},
	{
		id: 'item_36',
		image: '/images/nft-game/nft_game_character_4.png',
		creatorImage: '/images/avatars/creator_3.png',
		ownerImage: '/images/avatars/owner_3.png',
		price: '4.7 ETH',
		likes: '260',
		creatorname: 'Origin Morish',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		title: 'VR Space_287',
	},
	{
		id: 'item_37',
		image: '/images/nft-game/nft_game_character_5.png',
		creatorImage: '/images/avatars/creator_3.png',
		ownerImage: '/images/avatars/owner_3.png',
		price: '4.7 ETH',
		likes: '260',
		creatorname: 'Origin Morish',
		ownerName: '@051_Hart',
		auction_timer: '636234213',
		text: 'Neque aut veniam consectetur magnam libero, natus eius numquam reprehenderit hic at, excepturi repudiandae magni optio odio doloribus? Facilisi lobortisal morbi fringilla urna amet sed ipsum.',
		title: 'VR Space_287',
	},
];

export { items_data };
